export default __webpack_public_path__ + "static/media/event-team-member-2.d4001459.jpg";